import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React from 'react'
import { GrEmptyCircle } from "react-icons/gr";
import { HiOutlineDotsCircleHorizontal } from "react-icons/hi";
import { FaRegTimesCircle } from "react-icons/fa";
import { FaRegCircle } from "react-icons/fa";
import { IoTriangleOutline } from "react-icons/io5";
import ProgressBar from 'react-bootstrap/ProgressBar';
import { Link, useNavigate } from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import { useParams, useLocation } from 'react-router-dom';
import { useEffect, useCallback, useState, useFocusEffect, useContext } from 'react';
import axios from 'axios';
import { ProductContext } from "../context/AppContext";
import Footer from './Common_Components/Footer';

const JLPTQuiz = () => {
  // const route = useRoute();
  const location = useLocation();
  const navigate = useNavigate();
  const [activePage, setActivePage] = useState("Learning");
  // const { quizTypeId, quizName } = route.params;
  const authToken = localStorage.getItem("AuthToken");
  const QuizData = location.state;
 
  // const quizName = QuizData?.quiz_name;
  //  const quizTypeId = QuizData?.quiz_id;
  // const { quizTypeId } = location.state || {};
  // const { quizTypeId } = location.state || {};

  const quizTypeId = location?.state?.quizTypeId || QuizData?.quiz_id;
  const quizName = location?.state?.quizName || QuizData?.quiz_name;
  const isMockTestQuestionQuizType =
    Number(quizTypeId) === 11 ||
    String(quizName || '').toLowerCase() === 'mock test question';

  console.log(quizTypeId, "quizTypeId JLPT");
  console.log(quizName, "quizName JLPT");


  const [isSelected, setSelection] = useState(false);
  const [isSelected1, setSelection1] = useState(false);
  const [totalAttempts, setTotalAttempts] = useState(0);
  const [confirmAttempts, setConfirmAttempts] = useState(0);
  const [unAttempts, setUnAttempts] = useState(0);
  const [correctAttempts, setCorrectAttempts] = useState(0);
  const [incorrectAttempts, setIncorrectAttempts] = useState(0);
  const [reAttempts, setReAttempts] = useState(0);
  const totalQuestions = totalAttempts;
  const FirstTimeattemptQuestions = correctAttempts;
  const ReAttemptQuestion = reAttempts;
  const UnAttempsQuestion = unAttempts;
  const WrongattemptQuestions = incorrectAttempts;
  const ConfirmattemptQuestions = confirmAttempts;
  const [language, setLanguage] = useState('english');
  const [text, setText] = useState({});
  const { Translate } = useContext(ProductContext);
  // const attemptedQuestions =
  // ConfirmattemptQuestions +
  // FirstTimeattemptQuestions +
  // ReAttemptQuestion +
  // WrongattemptQuestions;

  useEffect(() => {
    const loadLanguage = async () => {
      try {
        const storedLanguage = await localStorage.getItem('selectedLanguage');
        setLanguage(storedLanguage || 'english');
      } catch (error) {
        console.error('Error loading language:', error);
      }
    };

    loadLanguage();
  }, []);


  const attemptedQuestions =
    ConfirmattemptQuestions +
    FirstTimeattemptQuestions +
    ReAttemptQuestion +
    WrongattemptQuestions;

  // const ConfirmFirstTimeAttempt = FirstTimeattemptQuestions / totalQuestions;
  const CorrectFirstTimeAttempt = FirstTimeattemptQuestions / totalQuestions;
  const ReAttemptProgress = ReAttemptQuestion / totalQuestions;
  const UnAttempsQuestionProgress = UnAttempsQuestion / totalQuestions;
  const wrongProgress = WrongattemptQuestions / totalQuestions;
  const ConfirmProgress = ConfirmattemptQuestions / totalQuestions;
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [quizTypeDetails, setQuizTypeDetails] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [activeLevelId, setActiveLevelId] = useState(null);
  console.log("color  :", CorrectFirstTimeAttempt, ReAttemptProgress, UnAttempsQuestionProgress, wrongProgress, ConfirmProgress);
  const [activeButton, setActiveButton] = useState(null);
  const [showListeningSelection, setShowListeningSelection] = useState(false);
  const [listeningCategoryData, setListeningCategoryData] = useState(null);
  const [examTypes, setExamTypes] = useState([]);
  const [testNames, setTestNames] = useState([]);
  const [questionTypes, setQuestionTypes] = useState([]);
  const [selectedExamId, setSelectedExamId] = useState('');
  const [selectedTestNameId, setSelectedTestNameId] = useState('');
  const [selectedQuestionTypeId, setSelectedQuestionTypeId] = useState('');
  const [isSelectionLoading, setIsSelectionLoading] = useState(false);
  const [selectionError, setSelectionError] = useState('');
  const [autoOpenedListeningSelection, setAutoOpenedListeningSelection] = useState(false);

  const fetchListeningExamTypes = async () => {
    setIsSelectionLoading(true);
    setSelectionError('');
    try {
      const response = await axios.get('https://api.japaking.online/api/exam-types', {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      const fetchedExamTypes = response?.data?.message?.examTypes || [];
      setExamTypes(fetchedExamTypes);
    } catch (error) {
      setSelectionError('Unable to load levels. Please try again.');
      console.log('Error fetching exam types:', error);
    } finally {
      setIsSelectionLoading(false);
    }
  };

  const fetchListeningTestNames = async () => {
    setIsSelectionLoading(true);
    setSelectionError('');
    try {
      const response = await axios.get('https://api.japaking.online/api/test-names', {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      const fetchedTestNames = response?.data?.message?.testNames || [];
      setTestNames(fetchedTestNames);
    } catch (error) {
      setSelectionError('Unable to load test names. Please try again.');
      console.log('Error fetching test names:', error);
    } finally {
      setIsSelectionLoading(false);
    }
  };

  const fetchListeningQuestionTypes = async () => {
    setIsSelectionLoading(true);
    setSelectionError('');
    try {
      const response = await axios.get('https://api.japaking.online/api/question-type-masters', {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      const fetchedQuestionTypes = response?.data?.message?.questionTypeMasters || [];
      setQuestionTypes(fetchedQuestionTypes);
    } catch (error) {
      setSelectionError('Unable to load question types. Please try again.');
      console.log('Error fetching question types:', error);
    } finally {
      setIsSelectionLoading(false);
    }
  };

  const openListeningSelection = (categoryId, categoryName) => {
    setListeningCategoryData({ categoryId, categoryName });
    setShowListeningSelection(true);
    setSelectedExamId('');
    setSelectedTestNameId('');
    setSelectedQuestionTypeId('');
    setTestNames([]);
    setQuestionTypes([]);
    fetchListeningExamTypes();
  };

  const closeListeningSelection = () => {
    setShowListeningSelection(false);
    setListeningCategoryData(null);
    setSelectionError('');
  };
  useEffect(() => {
    const getQuizTypeDetails = async () => {
      try {
        const response = await axios.get(
          `https://api.japaking.online/api/quizTypes/${quizTypeId}/details`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );

        if (response.data.success) {
          setQuizTypeDetails(response.data.message.quizDetails);
          const { attempts } = response.data.message.quizDetails;
          const {
            total_attempts,
            un_attempts,
            correct_attempts,
            incorrect_attempts,
            re_attempts,
            confirmed_attempts,
          } = attempts.counts[0];

          // Set state with dynamic data
          setTotalAttempts(total_attempts);
          setUnAttempts(un_attempts);
          setCorrectAttempts(correct_attempts);
          setIncorrectAttempts(incorrect_attempts);
          setReAttempts(re_attempts);
          setConfirmAttempts(confirmed_attempts);
        }
      } catch (error) {
        console.log('Error getting the quiz type:', error);
      } finally {
        setIsLoading(false);
      }
    };
    getQuizTypeDetails();
  }, [quizTypeId]);

  useEffect(() => {
    if (
      !QuizData?.openListeningSelection ||
      autoOpenedListeningSelection ||
      !quizTypeDetails?.categories?.categoryList?.length
    ) {
      return;
    }

    const listeningCategory =
      quizTypeDetails.categories.categoryList.find((category) => {
        const name = String(category?.category_name || "").toLowerCase();
        return name.includes("listen");
      }) || quizTypeDetails.categories.categoryList[0];

    if (listeningCategory) {
      setAutoOpenedListeningSelection(true);
      openListeningSelection(
        listeningCategory.category_id,
        listeningCategory.category_name,
      );
    }
  }, [QuizData?.openListeningSelection, autoOpenedListeningSelection, quizTypeDetails]);

  //     const handleCategorySelect = (categoryName, categoryId) => {
  //     setSelectedCategory({ id: categoryId, name: categoryName });
  // };
  const handleCategorySelect = (categoryName, categoryId) => {
    setSelectedCategory({ id: categoryId, name: categoryName });
    setActiveButton('category');
    setActiveButton('takeQuiz');
    handlePressNavigation(categoryId, categoryName);
  };


  const handlePress = level_id => {
    // console.log("this is the level id which is set ", level_id)
    setActiveLevelId(level_id);
  };
  useEffect(
    useCallback(() => {
      setSelectedCategory(null);
    }, []),
  );

  useEffect(() => {
    if (quizTypeDetails?.categories?.level?.level_id) {
      setActiveLevelId(quizTypeDetails.categories.level.level_id);
    }
  }, [quizTypeDetails]);

  const handlePressNavigation = (categoryId, categoryName) => {
    if (!categoryId) {
      return;
    }

    const normalizedCategory = String(categoryName || '').toLowerCase();
    const isListeningCategory =
      categoryName === 'Listening' ||
      categoryName === 'सुनने का अभ्यास' ||
      normalizedCategory.includes('listen');
    const isReadingGrammarVocabCategory =
      categoryName === 'Reading' ||
      categoryName === 'पढ़ने का अभ्यास' ||
      normalizedCategory.includes('read') ||
      normalizedCategory.includes('grammar') ||
      normalizedCategory.includes('grammer') ||
      normalizedCategory.includes('vocab') ||
      normalizedCategory.includes('व्याकरण') ||
      normalizedCategory.includes('शब्द');

    if (isMockTestQuestionQuizType) {
      if (isListeningCategory) {
        openListeningSelection(categoryId, categoryName);
        return;
      }

      if (isReadingGrammarVocabCategory) {
        openListeningSelection(categoryId, categoryName);
        return;
      }
    }

    if (categoryName === 'Reading' || categoryName === 'पढ़ने का अभ्यास') {
      navigate('/ReadingQuiz', {
        state: {
          category_id: categoryId,
          level_id: activeLevelId,
          categoryName: categoryName,
          quizTypeId,
          quizName
        },
      });
    } else if (
      categoryName === 'Writing' ||
      categoryName === 'लिखने का अभ्यास'
    ) {
      navigate('/writing-quiz', {
        state: {
          category_id: categoryId,
          level_id: activeLevelId,
          categoryName: categoryName,
          quizTypeId,
          quizName
        },
      });
    } else if (
      categoryName === 'Listening' ||
      categoryName === 'सुनने का अभ्यास'
    ) {
      if (isMockTestQuestionQuizType) {
        openListeningSelection(categoryId, categoryName);
      } else {
        navigate('/ListeningQuiz', {
          state: {
            category_id: categoryId,
            level_id: activeLevelId,
            categoryName: categoryName,
            quizTypeId,
            quizName
          },
        });
      }
    } else {
      navigate('/ReadingQuiz', {
        state: {
          category_id: categoryId,
          level_id: activeLevelId,
          categoryName: categoryName,
          quizTypeId,
          quizName
        },
      });
      // console.log("this is sent to queston1 ", activeLevelId, categoryName)
    }
  };

  useEffect(() => {
    if (!showListeningSelection || !selectedExamId) return;
    fetchListeningTestNames();
  }, [showListeningSelection, selectedExamId]);

  useEffect(() => {
    if (!showListeningSelection || !selectedTestNameId) return;
    fetchListeningQuestionTypes();
  }, [showListeningSelection, selectedTestNameId]);

  // Show all test names returned by API in the dropdown.
  const filteredTestNames = testNames;

  const canStartListeningQuiz =
    Boolean(listeningCategoryData?.categoryId) &&
    Boolean(selectedExamId) &&
    Boolean(selectedTestNameId) &&
    Boolean(selectedQuestionTypeId);

  const startListeningQuiz = () => {
    if (!canStartListeningQuiz) return;
    const normalizedCategory = String(listeningCategoryData?.categoryName || '').toLowerCase();
    const isListeningCategory =
      listeningCategoryData?.categoryName === 'Listening' ||
      listeningCategoryData?.categoryName === 'सुनने का अभ्यास' ||
      normalizedCategory.includes('listen');

    navigate(isListeningCategory ? '/MockTestListeningQuiz' : '/MockTestReadingQuiz', {
      state: {
        category_id: listeningCategoryData.categoryId,
        level_id: activeLevelId,
        categoryName: listeningCategoryData.categoryName,
        quizTypeId,
        quizName,
        exam_id: Number(quizTypeId),
        test_name_id: Number(selectedTestNameId),
        question_type_id: Number(selectedQuestionTypeId),
      },
    });
    closeListeningSelection();
  };

  const SelectLanguageLocal = localStorage.getItem("selectedLanguage");


  return (
    <div>
      <div className='JLPTQuiz_Container ' >
        <div className='col-md-12'>
          <div className='header_inner' >
            <div className='container'>
              <div className='row'>
                <div className='col-md-12'>
                  <ArrowBackIosIcon onClick={() => navigate('/Learn')} className='icon_1' />
                  <h2>{quizName}</h2>
                  <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container JLPT_Quiz" style={{ marginTop: "75px", marginBottom: "75px", height: "auto" }}>
          <div className="row">
            <div className="col-md-12">
              {/* <h3 className='mt-4 mb-4 ' style={{textAlign:"left", textDecoration:"underline"}} >N5</h3> */}
              {quizTypeDetails?.levels.slice().filter(level => level.level_name === "N5").map((QuizData, i) => (
                <div className="btn_JLPT" style={{ textAlign: "left" }}>
                  <button className='mt-4 mb-4 ' style={{ border: "1px", fontWeight: "600", fontSize: "15px", backgroundColor: "white" }}>{`${QuizData?.level_name}`}</button>
                </div>
              ))}
              {quizName !== 'Kanji Quiz' && (
                <div className="JLPTQuiz_btn d-flex justify-content-around p-2">
                  {/* Option 1: Using navigate with state */}
                  <div
                    onClick={() =>
                      navigate('/QwantTry', {
                        state: { category_id: quizTypeId, level_id: activeLevelId, status: 'confirm' },
                      })
                    }
                  >
                    <div className="JLPTQuiz-1">
                      <GrEmptyCircle size={30} color="white" />
                    </div>
                  </div>

                  {/* Option 2-5: Using navigate with default paths */}
                  <div
                    onClick={() =>
                      navigate('/QwantTry', {
                        state: { category_id: quizTypeId, level_id: activeLevelId, status: 'correct' }, // Add relevant states if needed
                      })
                    }
                  >
                    <div className="JLPTQuiz-2">
                      <FaRegCircle size={30} color="white" />
                    </div>
                  </div>

                  <div
                    onClick={() =>
                      navigate('/QwantTry', {
                        state: { category_id: quizTypeId, level_id: activeLevelId, status: 're_attempt' }, // Add relevant states if needed
                      })
                    }
                  >
                    <div className="JLPTQuiz-3">
                      <IoTriangleOutline size={30} color="white" />
                    </div>
                  </div>

                  <div
                    onClick={() =>
                      navigate('/QwantTry', {
                        state: { category_id: quizTypeId, level_id: activeLevelId, status: 'incorrect' }, // Add relevant states if needed
                      })
                    }
                  >
                    <div className="JLPTQuiz-4">
                      <FaRegTimesCircle size={30} color="white" />
                    </div>
                  </div>

                  <div
                    onClick={() =>
                      navigate('/QwantTry', {
                        state: { category_id: quizTypeId, level_id: activeLevelId, status: 'un_attempt' }, // Add relevant states if needed
                      })
                    }
                  >
                    <div className="JLPTQuiz-5">
                      <HiOutlineDotsCircleHorizontal size={30} color="white" />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="col-md-12">
            {quizName !== 'Kanji Quiz' && (
              <div className="JLPT_Quiz_Progres_bar mt-3 p-1">
                <p className="progress-text-left">{Translate?.message?.data?.overallProgress || "Overall Progress"}</p>
                <ProgressBar
                  visuallyHidden
                  className="JLPTQuiz_Progress_bar"
                >
                  <div
                    style={{
                      width: `${ConfirmProgress * 100}%`,
                      backgroundColor: 'darkblue',
                      height: '20px', // Optional: Specify height
                    }}
                  />
                  <div
                    style={{
                      width: `${CorrectFirstTimeAttempt * 100}%`,
                      backgroundColor: 'lightblue',
                      height: '20px', // Optional: Specify height
                    }}
                  />
                  <div
                    style={{
                      width: `${ReAttemptProgress * 100}%`,
                      backgroundColor: 'orange',
                      height: '20px', // Optional: Specify height
                    }}
                  />
                  <div
                    style={{
                      width: `${wrongProgress * 100}%`,
                      backgroundColor: 'red',
                      height: '20px', // Optional: Specify height
                    }}
                  />
                  <div
                    style={{
                      width: `${UnAttempsQuestionProgress * 100}%`,
                      backgroundColor: '#fff',
                      height: '20px', // Optional: Specify height
                    }}
                  />


                </ProgressBar>
                <p className="progress-text-right">{Translate?.message?.data?.totalAttempted || "Total Attempted:"}{totalAttempts}</p>
              </div>
            )}
          </div>

          <div className="container JLPT_Learning_Type">
            <div className="row justify-content-center">
              {quizTypeDetails?.categories?.categoryList?.map((QuizData, i) => {
                return (
                  <div
                    className="JLPT_Reading"
                    style={{
                      width: "500px",

                    }}
                    key={i}
                    onClick={() =>
                      handleCategorySelect(
                        quizTypeDetails.categories.categoryList[i]
                          ?.category_name,
                        quizTypeDetails.categories.categoryList[i]
                          ?.category_id,
                      )
                    }
                  >
                    {/* Image */}
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/images/writingLadki.jpeg`}
                      alt="Category Icon"
                      className="JLPT_learn_img"
                    />
                    {/* Text next to the image */}
                    <span className="JLPT_span">{QuizData?.category_name}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      {showListeningSelection && isMockTestQuestionQuizType && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
          }}
        >
          <div
            style={{
              backgroundColor: '#fff',
              width: '90%',
              maxWidth: '500px',
              borderRadius: '12px',
              padding: '20px',
            }}
          >
            <h4 style={{ marginBottom: '14px' }}>
              Start {listeningCategoryData?.categoryName || 'Listening'} Quiz Level
            </h4>

            <label style={{ display: 'block', marginBottom: '6px', fontWeight: 600 }}>Level</label>
            <select
              className='form-select'
              value={selectedExamId}
              onChange={(e) => {
                setSelectedExamId(e.target.value);
                setSelectedTestNameId('');
                setSelectedQuestionTypeId('');
                setQuestionTypes([]);
              }}
              disabled={isSelectionLoading}
            >
              <option value="">Select level</option>
              {examTypes.map((exam) => (
                <option key={exam.exam_id} value={exam.exam_id}>
                  {exam.exam_type}
                </option>
              ))}
            </select>

            <label style={{ display: 'block', marginBottom: '6px', marginTop: '14px', fontWeight: 600 }}>Test Name</label>
            <select
              className='form-select'
              value={selectedTestNameId}
              onChange={(e) => {
                setSelectedTestNameId(e.target.value);
                setSelectedQuestionTypeId('');
              }}
              disabled={isSelectionLoading}
            >
              <option value="">Select test name</option>
              {filteredTestNames.map((test) => (
                <option key={test.id} value={test.id}>
                  {test.test_name}
                </option>
              ))}
            </select>

            <label style={{ display: 'block', marginBottom: '6px', marginTop: '14px', fontWeight: 600 }}>Question Type</label>
            <select
              className='form-select'
              value={selectedQuestionTypeId}
              onChange={(e) => setSelectedQuestionTypeId(e.target.value)}
              disabled={!selectedTestNameId || isSelectionLoading}
            >
              <option value="">Select question type</option>
              {questionTypes.map((type) => (
                <option key={type.id} value={type.id}>
                  {type.name}
                </option>
              ))}
            </select>

            {selectionError && (
              <p style={{ color: 'red', marginTop: '10px', marginBottom: 0 }}>{selectionError}</p>
            )}

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
              <button className='btn btn-light' onClick={closeListeningSelection}>Cancel</button>
              <button
                className='btn btn-primary'
                disabled={!canStartListeningQuiz || isSelectionLoading}
                onClick={startListeningQuiz}
              >
                Start
              </button>
            </div>
          </div>
        </div>
      )}
            <Footer />
    </div>
  )
}

export default JLPTQuiz
